export default "__VITE_ASSET__apinoi2q__"